<template>
  <div class="short-page">
    <ui-alert v-if="msg" type="error" :dismissible="false">{{msg}}</ui-alert>
    <panel>
      <p slot="header">Zaloguj się</p>

      <form @submit.prevent="submit" autocomplete="off">
        <ui-textbox label="Twój e-mail" name="email" type="text" v-model="credentials.email" :autofocus="autofocus"></ui-textbox>

        <ui-textbox label="Twoje hasło" name="password" type="password" v-model="credentials.password"></ui-textbox>

        <ui-button color="primary">Zaloguj</ui-button>
      </form>
    </panel>
  </div>
</template>
<script>
import Auth from './../../services/Auth'
import EventEmitter from './../../services/EventEmitter'

export default {
  data() {
    return {
      opened: true,
      autofocus: true,
      msg: false,
      credentials: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    errorLogin() {
      this.msg =
        'Nie mogę Cię zalogować. Twój e-mail lub hasło jest niepoprawne'
    },
    successLogin(res) {
      Auth.saveToken(res.data.token)

      Auth.my().then(res => {
        Auth.setUser(res.data.user)
        EventEmitter.$emit('user.get', res.data.user)
      })

      this.$router.push({
        name: 'admin.home'
      })
    },
    submit() {
      this.msg = false
      Auth.login(this.credentials).then(this.successLogin, this.errorLogin)
    }
  }
}
</script>


// WEBPACK FOOTER //
// Login.vue?6d6354c0